var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownCircle24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.338 9.273l-.33-.328a.74.74 0 00-1.023.066l-3.971 3.931-4.016-3.997a.67.67 0 00-.731-.144.67.67 0 00-.217.144l-.331.328a.634.634 0 00-.185.681c.027.079.07.152.126.214l4.593 4.645.231.219a.641.641 0 00.449.218.638.638 0 00.456-.197l.235-.24 4.648-4.557a.725.725 0 00.066-.983z",
    clipRule: "evenodd"
  })));
}
export default SvgIconDownCircle24;